module.exports = __webpack_public_path__ + "img/logoBlureWhite.903010c8.svg";